module.exports = __webpack_public_path__ + "img/address-bg.59c14ad0.png";